import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
  Alert,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useHelpDocs from '../hooks/useHelpDocs';

const HelpAndSupport = ({ getAuthHeaders }) => {
  const { helpCategories, loading, error } = useHelpDocs({ getAuthHeaders });

  if (loading) {
    return (
      <Box sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ py: 4 }}>
      <Typography variant="body1" color="textPrimary" sx={{ mb: 4 }}>
        Find helpful information about how to use Reseller Pro. Click on any section below to expand and learn more.
      </Typography>

      <Divider sx={{ mb: 4 }} />

      {helpCategories.map((category, categoryIndex) => (
        <Accordion key={categoryIndex} defaultExpanded={false}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {category.category}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <List disablePadding>
                {category.questions.map((item, questionIndex) => (
                  <React.Fragment key={questionIndex}>
                    <ListItem
                      disableGutters
                      sx={{
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        mb: questionIndex < category.questions.length - 1 ? 2 : 0,
                      }}
                    >
                      <ListItemText
                        primary={item.question}
                        secondary={item.answer}
                        slotProps={{
                          primary: { variant: 'subtitle2', sx: { fontWeight: 600, mb: 1 } },
                        }}
                      />
                    </ListItem>
                    {questionIndex < category.questions.length - 1 && (
                      <Divider sx={{ my: 2 }} />
                    )}
                  </React.Fragment>
                ))}
              </List>
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default HelpAndSupport;
